var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevronExternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.033 3.336H1.398V21.4h18.065v-9.634M21.078 7.983V1.4m0 0h-6.583m6.583 0l-9.996 9.997",
    stroke: "#000064",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAyMiAyMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xMS4wMzI4IDMuMzM1ODdIMS4zOTgzN0wxLjM5ODM3IDIxLjQwMDRMMTkuNDYyOSAyMS40MDA0TDE5LjQ2MjkgMTEuNzY2IiBzdHJva2U9IiMwMDAwNjQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPg0KPHBhdGggZD0iTTIxLjA3ODMgNy45ODMyOVYxLjQwMDM5TTIxLjA3ODMgMS40MDAzOUgxNC40OTU0TTIxLjA3ODMgMS40MDAzOUMyMS4wNzgzIDEuNDAwMzkgMTQuNTA5NyA3Ljk2ODkzIDExLjA4MiAxMS4zOTY2IiBzdHJva2U9IiMwMDAwNjQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPg0KPC9zdmc+DQo=";
export { SvgIconChevronExternal as ReactComponent };